// Wizard v9 aoe_spells_spare_allies (owner 2026-10-09 "allies only") — the narrow SKIP-THE-CASTER'S-TEAM gate, kept dependency-free so the
// expansions and the zone replays (zones/) can read it without the provider walk. The caster's AREA spell is stamped cast-local
// computed.target_skip_same_team = 1 (caster-spell-layers.ts applyAoeSparesAllies); a persistent zone remembers it as
// status_opposing_team_only = 2 (0 none, 1 opposing only — Sanguine Careful, unchanged — 2 skip the caster's team). Neutral creatures and
// props are never skipped.
import { type Row, record, scalar, upper } from './context.js';

const filled = (value: unknown): boolean => {
  const v = scalar(value);
  return v !== null && v !== undefined && v !== '' && v !== 0 && v !== '0' && v !== false;
};
/** The per-cast "skip the caster's side" stamp (read straight off computed — never a catalog layer). */
export const TARGET_SKIP_SAME_TEAM = 'target_skip_same_team';
/** status_opposing_team_only's third value: a zone that skips its caster and the caster's team (neutrals / props still affected). */
export const ZONE_GATE_SKIP_SAME_TEAM = 2;

export function withSkipSameTeam(ability: Row): Row {
  return { ...ability, computed: { ...(record(ability.computed) ?? {}), [TARGET_SKIP_SAME_TEAM]: 1 } };
}
export function castSkipsSameTeam(ability: Row | null | undefined): boolean {
  return filled(record(ability?.computed)?.[TARGET_SKIP_SAME_TEAM]);
}

/** A creature row's team id (check_opposing_team's reader: the encounter row's team, else the layer; an item-shaped team → its id). */
function teamOf(row: Row, value: (row: Row, key: string) => unknown): string {
  const raw = scalar(record(row.encounter_creatures)?.team) ?? scalar(value(row, 'team'));
  return upper(scalar(record(record(raw)?.items)?.item_id) ?? raw);
}
/** The caster itself or a creature on the caster's own team (a teamless row — a prop, a neutral without a team — is never "same team"). */
export function sameTeamOrSelf(caster: Row, row: Row, value: (row: Row, key: string) => unknown): boolean {
  const casterId = upper(record(caster.encounter_creatures)?.encounter_creature_id);
  const rowId = upper(record(row.encounter_creatures)?.encounter_creature_id);
  if (casterId && rowId === casterId) return true;
  if (!rowId) return false;
  const ct = teamOf(caster, value);
  return ct !== '' && teamOf(row, value) === ct;
}

